module.exports = __webpack_public_path__ + "static/media/A6.a74809cc.mp3";